import { useCMSPageField } from '@/cms/fields'
import { space } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { Item } from './Item'
import { MealplansItem } from './MealplansItem'

export interface MealplansProps {
  title: string
}

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

const MealplansDescription = styled(Typography)`
  margin-bottom: ${space('primitives_space_8')};
  & :first-child {
    margin-top: 0;
    padding-top: 0;
  }
  & :last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

export function Mealplans({ title: mainTitle }: MealplansProps) {
  const mealplaninfo = useCMSPageField('PDP.mealplans')
  const items = mealplaninfo?.mealPlans

  // This is needed to get the correct description for the mealplan based on the type
  function getDescription(code: string) {
    const isAllInclusive = code === 'AI' || code === 'UA'
    if (!isAllInclusive) {
      return undefined
    }

    return mealplaninfo?.allInclusiveDescription
  }

  if (!items || items.length === 0) {
    return null
  }

  return (
    <Item elementDL="Mealplans" title={mainTitle} Glyph="ForkAndKnive">
      {mealplaninfo.description && (
        // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml -- This is a CMS field, and we trust the content
        <MealplansDescription as="div" dangerouslySetInnerHTML={{ __html: mealplaninfo.description }} />
      )}
      <ItemContent>
        {items.map(mealplan => (
          <MealplansItem
            key={mealplan.type.code}
            mealplanCode={mealplan.type.code}
            title={mealplan.type.description}
            description={getDescription(mealplan.type.code)}
          />
        ))}
      </ItemContent>
    </Item>
  )
}
